import { Routes } from '@angular/router';
import { PAGE } from './routes';
import { LoadingAuthGuard } from './core/guards/loading-auth.guard';
import { LocationBlockedGuard } from './core/guards/location-blocked.guard';
import { NoUpdateRequiredGuard } from './core/guards/no-update-required.guard';
import { AuthGuard } from './core/guards/auth.guard';
import { UpdateRequiredGuard } from './core/guards/update-required.guard';
import { NoAuthGuard } from './core/guards/no-auth.guard';
import { initialisedGuard } from './core/guards/initialised.guard';
import { geoLocationGuard } from './core/guards/geo-location.guard';
import { onboardingGuard } from './core/guards/onboarding.guard';

export const routes: Routes = [
  {
    path: '',
    canActivate: [LoadingAuthGuard],
    loadComponent: () => import('./features/loading/loading.page').then((m) => m.LoadingPage),
  },
  {
    path: PAGE.OPEN_WALLET,
    loadComponent: () =>
      import('./features/open-wallet/open-wallet.page').then((m) => m.OpenWalletPage),
  },
  {
    path: PAGE.UPDATE_REQUIRED,
    canActivate: [LocationBlockedGuard, NoUpdateRequiredGuard],
    loadComponent: () =>
      import('./features/update-required/update-required.page').then((m) => m.UpdateRequiredPage),
  },
  {
    path: PAGE.LOG,
    loadComponent: () => import('./features/log/log.page').then((m) => m.LogPage),
  },
  {
    path: PAGE.GEO_LOCATION_CHECK,
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./features/geo-location/geo-location-check/geo-location-check.page').then(
        (m) => m.GeoLocationCheckPage,
      ),
  },
  {
    path: PAGE.SIGNIN,
    canActivate: [LocationBlockedGuard, UpdateRequiredGuard, NoAuthGuard],
    loadComponent: () =>
      import('./features/sign-in/oauth-sign-in/sign-in.page').then((m) => m.SignInPage),
  },
  {
    path: PAGE.DEMO_SIGNIN,
    canActivate: [NoAuthGuard],
    loadComponent: () =>
      import('./features/sign-in/demo-sign-in/demo-sign-in.page').then((m) => m.DemoSignInPage),
  },
  {
    path: PAGE.ACCOUNT,
    canActivate: [
      geoLocationGuard,
      LocationBlockedGuard,
      UpdateRequiredGuard,
      AuthGuard,
      initialisedGuard,
    ],
    loadComponent: () => import('./features/account/account.page').then((m) => m.AccountPage),
  },
  {
    path: `${PAGE.LINK_WALLET}/:id`,
    canActivate: [
      geoLocationGuard,
      LocationBlockedGuard,
      UpdateRequiredGuard,
      AuthGuard,
      initialisedGuard,
    ],
    loadComponent: () =>
      import('./features/wallet/link-wallet/link-wallet.page').then((m) => m.LinkWalletPage),
  },
  {
    path: PAGE.SELECT_WALLET,
    canActivate: [
      geoLocationGuard,
      LocationBlockedGuard,
      UpdateRequiredGuard,
      AuthGuard,
      initialisedGuard,
    ],
    loadComponent: () =>
      import('./features/wallet/select-wallet/select-wallet.page').then((m) => m.SelectWalletPage),
  },
  {
    path: PAGE.TELEGRAM_ONBOARD,
    canActivate: [
      geoLocationGuard,
      LocationBlockedGuard,
      UpdateRequiredGuard,
      AuthGuard,
      initialisedGuard,
    ],
    loadComponent: () =>
      import('./features/telegram-onboard/telegram-onboard.page').then(
        (m) => m.TelegramOnboardPage,
      ),
  },
  {
    path: `${PAGE.GAME_VIEWER}/:gameId`,
    canActivate: [
      geoLocationGuard,
      LocationBlockedGuard,
      UpdateRequiredGuard,
      AuthGuard,
      initialisedGuard,
    ],
    loadComponent: () =>
      import('./features/game-viewer/game-viewer.page').then((m) => m.GameViewerPage),
  },
  {
    path: PAGE.UNAVAILABLE,
    loadComponent: () =>
      import('./features/unavailable/unavailable.page').then((m) => m.UnavailablePage),
  },
  {
    path: PAGE.PRIVACY,
    canActivate: [geoLocationGuard, LocationBlockedGuard, UpdateRequiredGuard],
    loadComponent: () => import('./features/privacy/privacy.page').then((m) => m.PrivacyPage),
  },
  {
    path: PAGE.TERMS,
    canActivate: [geoLocationGuard, LocationBlockedGuard, UpdateRequiredGuard],
    loadComponent: () => import('./features/terms/terms.page').then((m) => m.TermsPage),
  },
  {
    path: PAGE.RESPONSIBLE_GAMING,
    canActivate: [geoLocationGuard, LocationBlockedGuard, UpdateRequiredGuard],
    loadComponent: () =>
      import('./features/responsible-gaming/responsible-gaming.page').then(
        (m) => m.ResponsibleGamingPage,
      ),
  },
  {
    path: PAGE.FAQ,
    canActivate: [geoLocationGuard, LocationBlockedGuard, UpdateRequiredGuard],
    loadComponent: () => import('./features/faq/faq.page').then((m) => m.FaqPage),
  },
  {
    path: PAGE.CHOOSE_GAME,
    canActivate: [
      geoLocationGuard,
      LocationBlockedGuard,
      UpdateRequiredGuard,
      AuthGuard,
      initialisedGuard,
      onboardingGuard,
    ],
    loadComponent: () =>
      import('./features/choose-game/choose-game.page').then((m) => m.ChooseGamePage),
  },
  { path: '**', redirectTo: PAGE.CHOOSE_GAME },
];
